import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Ellipse = ({
  width = 114,
  height = 115,
  className,
  color,
  decorative = false,
  ariaLabel = "Ellipse",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 114 115"
      fill="none"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        stroke="#fff"
        strokeWidth="20"
        d="M104 57.5c0 26.316-21.125 47.5-47 47.5S10 83.816 10 57.5 31.125 10 57 10s47 21.184 47 47.5Z"
        opacity="0.3"
      ></path>
    </svg>
  );
};


